import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { loadGoogleAnalytics } from "../lib/analytics";

const KEY = "harman-cookie-consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(KEY);
    if (choice === "accepted") {
      loadGoogleAnalytics();
    } else if (!choice) {
      setVisible(true);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    if (value === "accepted") loadGoogleAnalytics();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 md:px-6 md:pb-6" data-testid="cookie-banner">
      <div className="max-w-[1100px] mx-auto glass-panel !rounded-2xl px-5 py-5 md:px-7 md:py-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6 shadow-[0_8px_40px_rgba(0,0,0,0.5),0_0_30px_rgba(0,168,255,0.15)]">
        <div className="flex items-start gap-3 flex-1">
          <span className="grid place-items-center w-10 h-10 shrink-0 rounded-xl bg-[rgba(0,168,255,0.15)] border border-[rgba(65,176,255,0.4)]">
            <Cookie size={20} className="text-[#39D5FF]" />
          </span>
          <p className="text-sm text-[#AEBFD8] leading-relaxed">
            We use cookies to improve your experience and analyse site traffic. By clicking Accept, you agree to our{" "}
            <Link to="/cookie-policy" className="text-[#39D5FF] hover:underline font-semibold">Cookie Policy</Link>.
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button onClick={() => decide("declined")} data-testid="cookie-decline"
            className="btn-secondary rounded-full px-6 py-2.5 text-sm font-semibold min-h-[44px] flex-1 md:flex-none">
            Decline
          </button>
          <button onClick={() => decide("accepted")} data-testid="cookie-accept"
            className="btn-primary rounded-full px-7 py-2.5 text-sm font-bold min-h-[44px] flex-1 md:flex-none">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
